export default "__VITE_ASSET__38edb73e__"